import React__default, { useState, useEffect } from 'react';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { View } from 'react-native';
import { A as AppDropDown } from './index-db6cb3b9.esm.js';
import { A as AppButton } from './AppButton-a3bdb006.esm.js';
import { A as AppTextInput } from './index-c2a07f56.esm.js';
import { A as AppSwitch } from './index-dbc9bff8.esm.js';

const subFeedbackTypeOptions = {
  multilanguage: [{
    id: "none",
    label: "None"
  }, {
    id: "translation",
    label: "Translation"
  }, {
    id: "languageDetection",
    label: "Language Detection"
  }, {
    id: "languageDetectionAndTranslation",
    label: "Language Detection and Translation"
  }],
  documentation: [{
    id: "none",
    label: "None"
  }, {
    id: "outdatedDocumentation",
    label: "Outdated Documentation"
  }, {
    id: "missingDocumentation",
    label: "Missing Documentation"
  }, {
    id: "incorrectDocumentation",
    label: "Incorrect Documentation"
  }],
  reasoning: [{
    id: "none",
    label: "None"
  }, {
    id: "incorrectAnswer",
    label: "Incorrect Answer"
  }, {
    id: "outOfContextAnswer",
    label: "Out of Context Answer"
  }],
  images: [{
    id: "none",
    label: "None"
  }, {
    id: "incorrectImage",
    label: "Incorrect Image"
  }, {
    id: "missingImage",
    label: "Missing Image"
  }],
  charting: [{
    id: "none",
    label: "None"
  }, {
    id: "incorrectChart",
    label: "Incorrect Chart"
  }, {
    id: "missingChart",
    label: "Missing Chart"
  }],
  api: [{
    id: "none",
    label: "None"
  }, {
    id: "incorrectApi",
    label: "Incorrect API"
  }, {
    id: "incorrectExecution",
    label: "Incorrect Execution"
  }, {
    id: "missingApi",
    label: "Missing API"
  }],
  moderation: [{
    id: "none",
    label: "None"
  }, {
    id: "incorrectModeration",
    label: "Incorrect Moderation"
  }, {
    id: "missingModeration",
    label: "Missing Moderation"
  }],
  html: [{
    id: "none",
    label: "None"
  }, {
    id: "incorrectHtml",
    label: "Incorrect HTML"
  }]
};
const MessageFeedback = _ref => {
  var _message$metadata, _message$callbackMeta, _message$metadata2, _currentTheme$theme, _currentTheme$theme2, _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7;
  let {
    message,
    handleFeedback,
    disableEditingFeedback = false,
    isOutputStream
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const [feedbackType, setFeedbackType] = React__default.useState(message === null || message === void 0 ? void 0 : message.humanFeedbackType);
  const [subFeedbackType, setSubFeedbackType] = React__default.useState(message === null || message === void 0 ? void 0 : message.humanFeedbackSubType);
  const [feedbackComment, setFeedbackComment] = React__default.useState((message === null || message === void 0 ? void 0 : message.humanFeedbackComment) || "");
  const [lastFeedback, setLastFeedback] = React__default.useState({
    feedbackType: message === null || message === void 0 ? void 0 : message.humanFeedbackType,
    feedbackComment: message === null || message === void 0 ? void 0 : message.humanFeedbackComment,
    subFeedbackType: message === null || message === void 0 ? void 0 : message.humanFeedbackSubType
  });
  const [useFeedbackForInstruction, setUseFeedbackForInstruction] = useState(message === null || message === void 0 ? void 0 : message.humanFeedbackForInstruction);
  const isDisabled = feedbackType === (message === null || message === void 0 ? void 0 : message.humanFeedbackType) && feedbackComment === (message === null || message === void 0 ? void 0 : message.humanFeedbackComment) && subFeedbackType === (message === null || message === void 0 ? void 0 : message.humanFeedbackSubType) || (lastFeedback === null || lastFeedback === void 0 ? void 0 : lastFeedback.feedbackType) === feedbackType && (lastFeedback === null || lastFeedback === void 0 ? void 0 : lastFeedback.feedbackComment) === feedbackComment && (lastFeedback === null || lastFeedback === void 0 ? void 0 : lastFeedback.subFeedbackType) === subFeedbackType || (message === null || message === void 0 ? void 0 : message.adminChecked);
  const exc_plan = [...((message === null || message === void 0 ? void 0 : (_message$metadata = message.metadata) === null || _message$metadata === void 0 ? void 0 : _message$metadata.executionPlan) || []), ...((message === null || message === void 0 ? void 0 : (_message$callbackMeta = message.callbackMetadata) === null || _message$callbackMeta === void 0 ? void 0 : _message$callbackMeta.executionPlan) || [])];
  const tar_language = message === null || message === void 0 ? void 0 : (_message$metadata2 = message.metadata) === null || _message$metadata2 === void 0 ? void 0 : _message$metadata2.targetLanguage;
  const [feedbackOptions, setFeedbackOptions] = React__default.useState([]);
  useEffect(() => {
    const options = [];
    if (exc_plan && !isOutputStream) {
      options.push("reasoning");
      if (exc_plan.includes("documentation")) options.push("documentation");
      if (tar_language) options.push("multilanguage");
      if (exc_plan.includes("image")) options.push("images");
      if (exc_plan.includes("chart")) options.push("charting");
      if (exc_plan.includes("api")) options.push("api");
      if (exc_plan.includes("moderation")) options.push("moderation");
      if (exc_plan.includes("html")) options.push("html");
      if (options.length > 0 && JSON.stringify(options) !== JSON.stringify(feedbackOptions)) {
        setFeedbackOptions(options);
        if (!feedbackType) setFeedbackType(options[0]);
      }
    } else if (isOutputStream && (feedbackOptions === null || feedbackOptions === void 0 ? void 0 : feedbackOptions.length) == 0) {
      setFeedbackOptions(["documentation", "reasoning", "multilanguage"]);
      if (!feedbackType) setFeedbackType("documentation");
    }
  }, [exc_plan, tar_language, feedbackType, isOutputStream]);
  useEffect(() => {
    if (feedbackType && !subFeedbackType) {
      setSubFeedbackType(subFeedbackTypeOptions[feedbackType][0]);
    }
  }, [feedbackType]);
  return (feedbackOptions === null || feedbackOptions === void 0 ? void 0 : feedbackOptions.length) > 0 ? /*#__PURE__*/React__default.createElement(View, {
    style: {
      marginTop: 5,
      borderTopWidth: 1,
      borderColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.border_color,
      paddingTop: 5
    }
  }, /*#__PURE__*/React__default.createElement(AppDropDown, {
    showTextInputLabel: true,
    label: "What's wrong with the answer?",
    inputLabelStyle: {
      marginLeft: 0,
      marginRight: 10
    },
    dropDownStyle: {
      minWidth: 100,
      borderColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.border_color,
      maxWidth: 200
    },
    isElevated: false,
    dropdownIconColor: "transparent",
    wrapperContainer: {
      flexDirection: "row",
      alignItems: "baseline",
      flexWrap: "wrap"
    },
    enabled: !disableEditingFeedback,
    items: feedbackOptions.map(item => ({
      id: item,
      name: item
    })),
    propertyLabel: "name",
    propertyValue: "id",
    selectedValue: feedbackType,
    onValueChange: (itemValue, itemIndex) => {
      setFeedbackType(itemValue);
    }
  }), /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement(AppDropDown, {
    showTextInputLabel: true,
    label: "Can you specify the category of the issue?",
    inputLabelStyle: {
      marginLeft: 0,
      marginRight: 10
    },
    enabled: !disableEditingFeedback,
    dropDownStyle: {
      minWidth: 100,
      borderColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.border_color,
      maxWidth: 200
    },
    isElevated: false,
    dropdownIconColor: "transparent",
    wrapperContainer: {
      flexDirection: "row",
      alignItems: "baseline",
      flexWrap: "wrap"
    },
    items: subFeedbackTypeOptions[feedbackType],
    propertyLabel: "label",
    propertyValue: "id",
    selectedValue: subFeedbackType,
    onValueChange: (itemValue, itemIndex) => {
      setSubFeedbackType(itemValue);
    }
  }), /*#__PURE__*/React__default.createElement(AppSwitch, {
    labelStyle: {
      paddingRight: 16
    },
    labelTextStyle: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.darkGrey
    },
    wrapperStyle: {
      paddingRight: 16,
      paddingVertical: 5
    },
    displayIsTicked: true,
    activeText: "True",
    inActiveText: "False",
    showTextInputLabel: true,
    label: "Instruct agent",
    isTicked: useFeedbackForInstruction,
    onChange: b => {
      setUseFeedbackForInstruction(b);
      setTimeout(() => {
        handleFeedback(message === null || message === void 0 ? void 0 : message._id, "negative", feedbackType, feedbackComment, subFeedbackType || (subFeedbackTypeOptions[feedbackType] || [])[0], b);
      }, 1000);
    }
  })), /*#__PURE__*/React__default.createElement(AppTextInput, {
    placeholder: "Please provide more details that help me understand how to improve",
    multiline: true,
    numberOfLines: 4,
    style: {
      marginTop: 2
    },
    wrapperInputStyle: {
      marginBottom: 10
    },
    textContainer: {
      margin: 0,
      padding: 10,
      minHeight: 120
    },
    disabled: disableEditingFeedback,
    type: "text",
    value: feedbackComment,
    onChangeText: text => {
      setFeedbackComment(text);
    }
  }), /*#__PURE__*/React__default.createElement(AppButton, {
    title: "Submit",
    isDisabled: isDisabled,
    onPress: () => {
      setLastFeedback({
        feedbackType,
        subFeedbackType: subFeedbackType || (subFeedbackTypeOptions[feedbackType] || [])[0],
        feedbackComment
      });
      handleFeedback(message === null || message === void 0 ? void 0 : message._id, "negative", feedbackType, feedbackComment, subFeedbackType || (subFeedbackTypeOptions[feedbackType] || [])[0], useFeedbackForInstruction);
    },
    backgroundColor: isDisabled ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.mediumGrey : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.primary,
    btnContentStyle: {
      paddingLeft: 0,
      paddingRight: 0
    },
    style: [{
      height: 30,
      width: "auto",
      shadowColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.transparent,
      marginRight: 10,
      marginLeft: 0
    }]
    // btnLabelStyle={{ fontSize: 16 }}
    ,
    wrapperStyle: [{
      width: "fit-content",
      minWidth: 150,
      alignSelf: isOutputStream && "center"
    }]
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
};
MessageFeedback.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MessageFeedback",
  "props": {
    "disableEditingFeedback": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};

export { MessageFeedback as M, subFeedbackTypeOptions as s };
